import { render, staticRenderFns } from "./PPOBTransaction.vue?vue&type=template&id=3940780f&"
import script from "./PPOBTransaction.vue?vue&type=script&lang=js&"
export * from "./PPOBTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports